<template>
  <div class="prizeDetail">
    <div class="breadcrumb">
      活动管理 > 奖品管理 > 查看详情
      <el-button
        class="right_f"
        type="primary"
        @click="importPrize"
        v-if="prize.online == 0"
        >移除并导出未发放奖品数据</el-button
      >
      <el-button class="right_f" type="primary" @click="goback">返回</el-button>
    </div>
    <div class="detail">
      <div class="panel">
        <span class="title imgSpan">奖品图标：</span>
        <img :src="prize.logoUrl" />
      </div>
      <div class="panel">
        <span class="title">奖品名称：</span>{{ prize.prizeName }}
      </div>
      <div class="panel">
        <span class="title">第三方奖励ID：</span>{{ prize.defineText1 }}
      </div>
      <div class="panel">
        <span class="title">发放时间：</span
        >{{ prize.deployStartTime }}&nbsp;至&nbsp;{{ prize.deployEndTime }}
      </div>
      <div class="panel">
        <span class="title">奖品类型：</span>{{ prize.prizeType }}
      </div>
      <div class="panel" style="height: 120px">
        <span class="title">奖励弹窗：</span>{{ prize.windowType }}
        <div v-show="prize.windowUrl">
          <img
            :src="prize.windowUrl"
            alt=""
            style="display: block; margin-left: 150px"
          />
        </div>
      </div>
      <div class="panel" v-if="prize.windowType == '自定义图片'">
        <span class="title">点击事件:</span>
        <span>{{ prize.windowClickType }}</span>
      </div>
      <div class="panel" v-if="prize.windowType == '自定义图片'">
        <span class="title">点击事件url:</span>
        <span>{{ prize.windowClickUrl }}</span>
      </div>

      <div class="panel">
        <span class="title">奖励里程：</span>{{ prize.prizeDisType }}
      </div>
      <div class="panel">
        <span class="title">兑奖URL：</span
        >{{ prize.prizeUrl || "同活动详情处URL" }}
      </div>
      <div class="panel ad" v-if="prize.adExposingCodes">
        <span class="title" style="float: left">广告曝光代码：</span>
        <div class="adCode">
          {{ prize.adExposingCodes }}
        </div>
      </div>
      <div class="panel" v-if="prize.redeemStartTime">
        <span class="title">兑奖有效期：</span
        >{{ prize.redeemStartTime }}&nbsp;至&nbsp;{{ prize.redeemEndTime }}
      </div>
      <div class="panel" v-if="prize.redeemText">
        <span class="title">兑换码文字说明：</span>{{ prize.redeemText }}
      </div>
      <div class="panel" v-if="prize.defineText2">
        <span class="title">自定义文案：</span> {{ prize.defineText2 }}
      </div>
      <div class="panel">
        <span class="title">奖品详细数据：</span>  {{prize.prizeFromType}} {{prize.prizeNum}}个
         {{prize.prizeFromType=='总共'?'（所有参与学校均可领取）':""}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      prize: {},
      prizeId: "",
    };
  },
  mounted() {
    //获取奖品详情
    this.prizeId = this.$util.getUrlParam("prizeId");
    this.getprizeDetail(this.prizeId);
  },
  methods: {
    getprizeDetail(id) {
      this.$http({
        method: "POST",
        url:
          this.$util.domain +
          "/adminapi/v2/operate/prize/queryByPrizeId?prizeId=" +
          id,
      }).then((response) => {
        if (response.data.error === 10000) {
          console.log("详情页详情接口", response.data);
          let data = response.data.data;

          if (data.windowClickType == 1) {
            data.windowClickType = "H5地址:";
          } else if (data.windowClickType == 2) {
            data.windowClickType = "文章ID:";
          } else if (data.windowClickType == 0) {
            data.windowClickType = "不跳转";
            data.windowClickUrl = "";
          } else if (data.windowClickType == 4) {
            data.windowClickType = "微信小程序-";
            // 小程序地址拆分
            let clickEvent = "";
            let wxAppId = this.$util.getUrlParam("id", data.windowClickUrl);
            let wxAppUrl = this.$util.getUrlParam("path", data.windowClickUrl);
            if (wxAppUrl) {
              clickEvent = "原始id：" + wxAppId + "， 小程序地址：" + wxAppUrl;
            } else {
              clickEvent = "原始id：" + wxAppId;
            }
            data.windowClickUrl = clickEvent;
          } else if (data.windowClickType == 5) {
            data.windowClickType = "音频-";
            let albumId = this.$util.getUrlParam("id", data.windowClickUrl),
              nickName = this.$util.getUrlParam(
                "nickName",
                data.windowClickUrl
              ),
              albumCount = this.$util.getUrlParam("count", data.windowClickUrl),
              isPaid =
                this.$util.getUrlParam("isPaid", data.windowClickUrl) == 1
                  ? "是"
                  : "否";

            data.windowClickUrl =
              "专辑id：" +
              albumId +
              "，主播名称：" +
              nickName +
              "，单曲数：" +
              albumCount +
              "，是否付费：" +
              isPaid;
          } else if (data.windowClickType == 7) {
            data.windowClickType = "支付宝小程序-";
            // 小程序地址拆分
            let clickEvent = "";
            let wxAppId = this.$util.getUrlParam("appId", data.windowClickUrl);
            let wxAppUrl = this.$util.getUrlParam("page", data.windowClickUrl);
            let query = this.$util.getUrlParam("query", data.targetUrl);
            if (wxAppUrl) {
              clickEvent = "原始id：" + wxAppId + "， 小程序地址：" + wxAppUrl;
            } else {
              clickEvent = "原始id：" + wxAppId;
            }
            if (query) {
              clickEvent = clickEvent + "，参数：" + query;
            }
            data.windowClickUrl = clickEvent;
          } else {
            data.windowClickType = "话题ID:";
          }
          data.deployStartTime = new Date(data.deployStartTime);
          data.deployEndTime = new Date(data.deployEndTime);
          data.redeemStartTime =
            data.redeemStartTime != -1 ? new Date(data.redeemStartTime) : null;
          data.redeemEndTime =
            data.redeemEndTime != -1 ? new Date(data.redeemEndTime) : null;
          data.deployStartTime = data.deployStartTime.format("yyyy/MM/dd");
          data.deployEndTime = data.deployEndTime.format("yyyy/MM/dd");
          data.redeemStartTime = data.redeemStartTime
            ? data.redeemStartTime.format("yyyy/MM/dd")
            : null;
          data.redeemEndTime = data.redeemEndTime
            ? data.redeemEndTime.format("yyyy/MM/dd")
            : null;
          data.import = data.import ? "已导入" : "未导入";
          data.prizeType =
            data.prizeType == 1
              ? "必中"
              : data.prizeType == 2
              ? "随机中"
              : "限量";
          data.windowType = data.windowType == 0 ? "默认" : "自定义图片";

          if (data.prizeDisType == 1) {
            data.prizeDisType = "不奖励";
          } else if (data.prizeDisType == 2) {
            data.prizeDisType = "双倍奖励";
          } else if (data.prizeDisType == 3) {
            // 自定义类型：显示奖励公里数和奖励次数
            let prizeDisTypeText = "奖励" + data.prizeDis + "公里";
            if (data.prizeTimes) {
              prizeDisTypeText += "，奖励" + data.prizeTimes + "次";
            }
            data.prizeDisType = prizeDisTypeText;
          }
          data.prizeFromType = data.prizeFromType==1 ? "总共" : "每个学校";  


          this.prize = data;
        }
      });
    },
    importPrize() {
      if (this.prize.online == "0") {
        location.href =
          this.$util.domain +
          "/adminapi/v1/operate/prize/export?prizeId=" +
          this.prizeId;
      } else {
        this.$util.errorMsg("当前活动不是未发布状态");
      }
    },
    goback() {
      history.back();
    },
  },
};
</script>

<style>
.prizeDetail {
  height: 100%;
}

.prizeDetail .detail {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
}

.prizeDetail .title {
  display: inline-block;
  width: 150px;
  text-align: right;
}

.prizeIcon {
  position: relative;
  top: -70px;
}

.prizeItem {
  height: 40px;
}

.prizeDetail .detail {
  margin-left: 20px;
  overflow: hidden;
}

.prizeDetail .imgSpan {
  position: relative;
  top: -60px;
}

.prizeDetail .campSpan {
  position: relative;
  top: -15px;
}

.prizeDetail .panel {
  height: 80px;
}

.prizeDetail img {
  display: inline-block;
  width: 137px;
  height: 74px;
}

.prizeDetail .contain {
  display: inline-block;
  padding: 15px 10px;
  width: 80%;
  height: 135px;
  box-sizing: border-box;
  border: solid 1px #999;
}

.prizeDetail #targetCamp {
  height: 135px;
}

.prizeDetail .targetCamp {
  border: solid 1px #999;
  box-sizing: border-box;
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 15px;
}

.prizeDetail .ad {
  height: auto;
  max-height: 300px;
  margin-bottom: 20px;
  overflow-y: scroll;
}

.prizeDetail .adCode {
  float: left;
  width: calc(100% - 180px);
}
</style>


// WEBPACK FOOTER //
// prizeDetail.vue?3e4b06c6